export default function Hero() {
  const scrollToPurchase = () => {
    const purchaseSection = document.getElementById('purchase-section');
    if (purchaseSection) {
      purchaseSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Imagem de fundo para Desktop */}
      <div 
        className="absolute inset-0 bg-cover bg-center hidden md:block"
        style={{
          backgroundImage: 'url(https://static.readdy.ai/image/d9a90a3a33c103674e2a9b61d59bf53a/f0b012cf61c1ef23a2d90c5682ddacef.png)',
          backgroundPosition: 'center top'
        }}
      ></div>
      
      {/* Imagem de fundo para Mobile */}
      <div 
        className="absolute inset-0 bg-cover md:hidden"
        style={{
          backgroundImage: 'url(https://static.readdy.ai/image/d9a90a3a33c103674e2a9b61d59bf53a/472c405b93403cf0965da262f25c1a9d.png)',
          backgroundPosition: 'center center',
          backgroundSize: 'cover'
        }}
      ></div>
      
      <div className="absolute inset-0 bg-gradient-to-b from-[#0A2463]/60 via-[#0A2463]/50 to-[#0A2463]/70"></div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 py-20 text-center">
        <div className="mb-6 inline-block">
          <span className="bg-[#FFB800] text-[#0A2463] px-6 py-2 rounded-full text-sm font-bold tracking-wide">
            🎓 MÉTODO COMPROVADO
          </span>
        </div>

        <h1 className="text-5xl md:text-7xl font-bold text-white mb-6 leading-tight">
          Transforme Seu Cão em um
          <span className="block text-[#FFB800] mt-2">Companheiro Obediente</span>
        </h1>

        <p className="text-xl md:text-2xl text-gray-200 mb-8 max-w-3xl mx-auto leading-relaxed">
          Descubra o método passo a passo que já ajudou mais de 15.000 tutores a educar seus cães de forma positiva e eficaz
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-12">
          <button 
            onClick={scrollToPurchase}
            className="group bg-[#FFB800] hover:bg-[#FFA500] text-[#0A2463] px-10 py-5 rounded-full text-lg font-bold transition-all duration-300 transform hover:scale-105 shadow-2xl whitespace-nowrap cursor-pointer flex items-center gap-3"
          >
            <span>Quero Transformar Meu Cão Agora</span>
            <i className="ri-arrow-right-line text-2xl group-hover:translate-x-1 transition-transform"></i>
          </button>
        </div>

        <div className="flex flex-wrap justify-center gap-8 text-white">
          <div className="flex items-center gap-2">
            <i className="ri-check-double-line text-[#FFB800] text-2xl"></i>
            <span className="text-base">Acesso Imediato</span>
          </div>
          <div className="flex items-center gap-2">
            <i className="ri-shield-check-line text-[#FFB800] text-2xl"></i>
            <span className="text-base">Garantia de 07 Dias</span>
          </div>
        </div>

        <div className="mt-16 grid grid-cols-1 gap-6 max-w-md mx-auto">
          <div className="bg-white/10 backdrop-blur-sm border border-white/20 rounded-2xl p-6">
            <div className="w-14 h-14 bg-[#FFB800] rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-book-open-line text-[#0A2463] text-2xl"></i>
            </div>
            <h3 className="text-white font-bold text-lg mb-2">150+ Páginas</h3>
            <p className="text-gray-300 text-sm">Conteúdo completo e ilustrado</p>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-white text-3xl"></i>
      </div>
    </section>
  );
}